var cov_2dx8gonaz1 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/InputTitle/styles/index.js",
      hash = "616e8430960d1dae2e105d894c8769d949b1bf65",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/InputTitle/styles/index.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 31
        },
        end: {
          line: 4,
          column: 76
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var inputTitleLess = {};
import genaration from '../../utils/classname';
export var inputTitleClass = (cov_2dx8gonaz1.s[0]++, genaration(inputTitleLess, 'input-title-box'));